import { DatePicker } from '@cobliteam/ui/components';
import { FormControl, FormField, FormItem, FormLabel, FormMessage, useFormContext } from '@cobliteam/ui/form';
import { addDays, endOfDay, startOfDay } from '@cobliteam/utils/date';
import LicenseExpiredTooltip from './LicenseExpiredTooltip';

const DriverLicenseDateInput = () => {
  const { watch } = useFormContext();

  const firstLicenseDate = watch('firstLicenseAcquirementDateInMillis');
  const expirationLicenseDate = watch('licenseExpirationDateInMillis');

  return (
    <div className={'flex gap-3'}>
      <FormField name='firstLicenseAcquirementDateInMillis'>
        {({ field }) => {
          const today = new Date();
          const [maxFirstLicenseData] = [today, expirationLicenseDate].sort();

          return (
            <FormItem className='w-full space-y-1'>
              <FormLabel>1ª Habilitação</FormLabel>
              <FormControl>
                <div data-testid='license-acquirement-date-input'>
                  <DatePicker
                    mode='single'
                    placeholder='Selecione a data'
                    onSelect={(date?: Date) => field.onChange(date?.getTime())}
                    yearsRange={{ from: 1970, to: new Date().getFullYear() }}
                    disabledDays={{
                      after: endOfDay(maxFirstLicenseData),
                    }}
                    selected={field.value ? new Date(field.value) : undefined}
                    portal={false}
                  />
                </div>
              </FormControl>
              <FormMessage />
            </FormItem>
          );
        }}
      </FormField>
      <FormField name='licenseExpirationDateInMillis'>
        {({ field }) => {
          const minAllowedExpirationDate = firstLicenseDate ? startOfDay(addDays(firstLicenseDate, 1)) : new Date();

          return (
            <FormItem className='w-full space-y-1'>
              <FormLabel className='flex items-center gap-1'>Validade {field.value && <LicenseExpiredTooltip date={field.value} />}</FormLabel>
              <FormControl>
                <div data-testid='license-expiration-date-input'>
                  <DatePicker
                    mode='single'
                    placeholder='Selecione a data'
                    onSelect={(date?: Date) => field.onChange(date?.getTime())}
                    yearsRange={{ from: 1970, to: new Date().getFullYear() + 10 }}
                    disabledDays={{
                      before: minAllowedExpirationDate,
                    }}
                    selected={field.value ? new Date(field.value) : undefined}
                    portal={false}
                  />
                </div>
              </FormControl>
              <FormMessage />
            </FormItem>
          );
        }}
      </FormField>
    </div>
  );
};

export default DriverLicenseDateInput;
